import {ChangeDetectorRef, Component} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ElementRef} from '@angular/core';
import {SubFormComponent} from '../../_subform';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';

/*
* Блок паспортных данных специалиста
* */

@Component({
    providers: [
    ],
    selector: 'specialist-form-fields-passport',
    templateUrl: './specialist-form-fields-passport.component.html'
})
export class SpecialistFormFieldsPassportComponent extends SubFormComponent {

    /**
     * Паспорт иностранного гражданина?
     * @type {boolean}
     */
    public isForeign = false;

    public formGroupTemplate = this._fb.group({
        // Паспортные данные
        passport_date: [''], // Дата выдачи
        passport_issue: [''], // Кем выдан
        passport_series: [''], // Серия
        passport_number: [''], // Номер
        is_foreign: [false],
        file_passport: this._fb.group({ // Сканированая копия
            file_id: [''],
            file_url: ['']
        }),
    });

    constructor(public elementRef: ElementRef,
                private changeDetectionRef: ChangeDetectorRef,
                private _fb: FormBuilder) {
        super();
    }

    afterInit() {
        this.isForeign = Boolean(this.form.get('is_foreign').value);

        this.subs.push(
            this.form.get('is_foreign').valueChanges.pipe(
                map((v: any) => Boolean(v)), // От Backend приходит 0 или 1, поэтому приводим к boolean
                distinctUntilChanged(),
            ).subscribe((isForeign: boolean) => {
                /**
                 * @TODO distinctUntilChanged не учитывает дефолтное значение при проверке, изменилось ли оно,
                 * поэтому приходится дополнительно проверять с дефолтным вручную.
                 * Возможно в RXJS6 другое поведение. Проверить после обновления
                 */
                if (this.isForeign === isForeign) {
                    return;
                }
                this.isForeign = isForeign;
                this.form.get('passport_number').patchValue(null);
                this.form.get('passport_series').patchValue(null);
            }),
            /**
             * если указать у поля атрибут mxlength, то
             * https://github.com/RobinHerbots/Inputmask все равно его превышает.
             * Решаем кардинальным, но надежным способом, запрещая полям паспорта превышать 20 символов
             */
            this.form.get('passport_number').valueChanges.pipe(
                distinctUntilChanged(),
                filter((v: string) => v && v.length > 20),              // Все что больше 20 символов
                map((v: string) => v.substr(0, 20))     // Режем до 20 ровно
            ).subscribe((v) => this.form.get('passport_number').patchValue(v)), // И записываем в поле
            this.form.get('passport_series').valueChanges.pipe(
                distinctUntilChanged(),
                filter((v: string) => v && v.length > 20),
                map((v: string) => v.substr(0, 20))
            ).subscribe((v) => this.form.get('passport_series').patchValue(v)),
        );
    }
}
